/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "Security": {
                                "fields": {
                                  "passcodesEnabled": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "allowTeamPasscode": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "teamPasscode": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "requirePasscodeAfterEachSale": {
                                    "type": "bool",
                                    "id": 4,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "requirePasscodeWhenBackingOutOfSale": {
                                    "type": "bool",
                                    "id": 5,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "requirePasscodeAfterLogout": {
                                    "type": "bool",
                                    "id": 6,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "requirePasscodeWhenBackingOutOfBuyerFacingScreen": {
                                    "type": "bool",
                                    "id": 12,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "requirePasscodeAfterTimeout": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Security.PasscodeTimeout",
                                    "id": 7,
                                    "rule": "optional",
                                    "options": {
                                      "default": "NEVER"
                                    }
                                  },
                                  "legacyTrackTime": {
                                    "type": "bool",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "legacyEnabledForAccount": {
                                    "type": "bool",
                                    "id": 9,
                                    "rule": "optional"
                                  },
                                  "legacyBreakTrackingEnabled": {
                                    "type": "bool",
                                    "id": 10,
                                    "rule": "optional"
                                  },
                                  "legacyDeviceUdid": {
                                    "type": "string",
                                    "id": 11,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "PasscodeTimeout": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "NEVER": 1,
                                      "THIRTY_SECONDS": 2,
                                      "ONE_MINUTE": 3,
                                      "FIVE_MINUTES": 4
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.Security && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.Security?.nested?.PasscodeTimeout) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE Security @ squareup/devicesettings/profiles/v2/model/settings/common/security.proto at 17:1
 */
export const Security = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.Security');
fixType(Security);
Builder.createAndAttachToType(Security);
/**
 * SOURCE PasscodeTimeout @ squareup/devicesettings/profiles/v2/model/settings/common/security.proto at 27:3
 */
Security.PasscodeTimeout = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.Security.PasscodeTimeout').values;